<!-- Copied and adjusted from https://bitbucket.org/home_search/homesearch-vue-property/src/master/src/components/v-multiselect-autocomplete/VMultiSelectAutocomplete.vue -->
<!-- Adjustments: changed layout and styling -->
<template>
  <div class="multiselect-autocomplete-ui" @click.self="triggerAutocompleteFocus">
    <div v-if="!disabled" class="multiselect-autocomplete-ui__control">
      <SearchAutocomplete
        v-model="searchValue"
        :placeholder="placeholder"
        :variant-class-name="variationClassName"
        :search-result-field="searchResultField"
        :trigger-focus="triggerFocus"
        :disabled="disabled"
        :search-performer="searchPerformer"
        :search-min-chars="searchMinChars"
        @on-select-item="onItemSelect"
      />
    </div>
    <ul v-if="selection.length" class="multiselect-autocomplete-ui__selection">
      <li
        v-for="(item, index) in selection"
        :key="index"
        class="multiselect-autocomplete-ui__selection-item"
      >
        {{ getItemLabel(item) }}
        <CircleCloseBtn
          title="Remove"
          class="multiselect-autocomplete"
          @click="emitOnSelectionRemove(item)"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  // Types
  import type { PropType } from 'vue';
  import type { TSearchPerformer } from '~/misc/search/types';

  // Components
  import SearchAutocomplete from '~/misc/search/autocomplete/SearchAutocomplete.vue';
  import CircleCloseBtn from '~/misc/btn/circle-close/CircleCloseBtn.vue';

  export default defineComponent({
    name: 'MultiSelectAutocomplete',
    components: { SearchAutocomplete, CircleCloseBtn },
    props: {
      modelValue: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      searchResultField: {
        type: String,
        default: '',
      },
      selectionDisplayKey: {
        type: String,
        default: '',
      },
      selection: {
        type: Array as PropType<unknown[]>,
        default: (): unknown[] => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      searchPerformer: {
        type: Object as PropType<TSearchPerformer>,
        required: true,
      },
      searchMinChars: {
        type: Number,
        default: 1,
      },
      variationClassName: {
        type: String,
        default: '',
      },
    },
    emits: ['update:modelValue', 'on-selection-add', 'on-selection-remove'],
    data: (): {
      triggerFocus: boolean;
    } => ({
      triggerFocus: false,
    }),
    computed: {
      searchValue: {
        get(): string {
          return this.modelValue;
        },
        set(value: string) {
          this.emitInput(value);
        },
      },
    },
    methods: {
      onItemSelect(item: unknown) {
        this.emitOnSelectionAdd(item);
        this.triggerAutocompleteFocus();
        this.emitInput('');
      },
      triggerAutocompleteFocus() {
        this.triggerFocus = !this.triggerFocus;
      },
      getItemLabel(item: unknown): unknown {
        return this.selectionDisplayKey && typeof item === 'object'
          ? (item as Record<string, unknown>)[this.selectionDisplayKey]
          : item;
      },
      emitInput(value: string) {
        this.$emit('update:modelValue', value);
      },
      emitOnSelectionAdd(item: unknown) {
        this.$emit('on-selection-add', item);
      },
      emitOnSelectionRemove(item: unknown) {
        this.$emit('on-selection-remove', item);
      },
    },
  });
</script>
